import Link from 'next/link';
import type { CategoryLinkProps } from './types';

const CategoryLink: React.FC<CategoryLinkProps> = ({ category, children }) => {
  const encodedSlug = encodeURIComponent(category.slug);
  return (
    <Link href={`/travel-journal/${encodedSlug}`} key={category.id}>
      <a>{children}</a>
    </Link>
  );
};

export default CategoryLink;
